import { useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';

const withModalView = WrappedComponent => {
  const Container = props => {
    useEffect(() => {
      document.body.classList.add('modal-open');

      return () => {
        document.body.classList.remove('modal-open');
      };
    }, []);

    const history = useHistory();

    const back = e => {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      history.push(props.backUrl);
    };

    return (
      <div className="modal d-flex justify-content-between">
        <div className="modal-space"></div>
        <div className="modal-container shadow flex-fill">
          <div className="container pt-4">
            <button className="btn-close" onClick={back}>
              <FiX size={22} />
            </button>
            <WrappedComponent {...props} back={back} />
          </div>
        </div>
      </div>
    );
  };

  return Container;
};

export default withModalView;
